/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { Check, Text } from '@myinterview/component-library';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ALL_JOB_QUESTIONS_TYPE, ANSWER_TYPES } from '../interfaces/jobInterface';
import { VIDEO_STATUS } from '../interfaces/videoInterface';
import { QuestionParameters } from './QuestionParamaters';

interface IProps {
  questionObj: ALL_JOB_QUESTIONS_TYPE;
  questionNumber: number;
  currentQuestion: number;
  isPracticeMode: boolean;
  questionStatus: VIDEO_STATUS;
}

export const QuestionItem:React.FC<IProps> = ({
  questionObj, questionNumber, currentQuestion, isPracticeMode, questionStatus,
}) => {
  const { t } = useTranslation();
  const questionItemRef = useRef<HTMLDivElement>(null);
  const isCurrentQuestion = currentQuestion === questionNumber;
  const isQuestionPast = currentQuestion > questionNumber;
  const status = isPracticeMode ? isQuestionPast : questionStatus;
  const questionItemClassNames = classNames({
    'myinterview-widget-questions-item': true,
    'myinterview-widget-questions-item--active': isCurrentQuestion,
  });
  const questionItemNumberClassNames = classNames({
    'myinterview-widget-questions-item__number': true,
    'myinterview-widget-questions-item__number--icon': !!status,
  });

  useEffect(() => {
    if (questionItemRef.current && isCurrentQuestion) {
      questionItemRef.current.scrollIntoView(false);
    }
  }, [questionItemRef.current]);

  return (
    <div ref={questionItemRef} className={questionItemClassNames}>
      <div className={questionItemNumberClassNames}>{status ? <Check /> : questionNumber}</div>
      <div className="myinterview-widget-questions-item__wrapper">
        <div className="myinterview-widget-questions-item__question">
          <Text className="myinterview-text--truncated" size="S-Semibold">{`${t('questionList.name')} ${questionNumber}`}</Text>
          <div className="myinterview-widget-questions-item__duration-wrapper">
            <QuestionParameters answerType={questionObj.answerType || ANSWER_TYPES.VIDEO} duration={questionObj.partDuration} takes={questionObj.numOfRetakes} />
          </div>
        </div>
      </div>
    </div>
  );
};
